module.exports = __webpack_public_path__ + "media/img/home/sections-parralax/clients-parralax-531b3a0206d0739d51523d48a56fc814.svg";